import React, { useState } from "react";
import FormFieldSet from "../../FormFields/FormFieldSet";

export const DrawerWorkflowStep = ({
  workflows,
  setWorkflows,
  multiple,
  hideApprovers
}) => {
  console.log({ workflows });
  return (
    <div className="space-y-4">
      <h3 className="text-lg font-semibold text-gray-800">
        Configure Approvers
      </h3>

      <div className="p-4 border rounded-lg">
        <div className="flex items-center mb-3">
          <h4 className="font-semibold text-sm">Workflow</h4>
        </div>

        <div className="space-y-3">
          <div>
            <FormFieldSet
              type="usersForEonboarding"
              title="Initiator"
              multiple={multiple}
              placeholder="Select Initiators"
              value={workflows[0]?.initiator || ""}
              onChange={(value) => {
                const newWorkflows = [...workflows];
                newWorkflows[0].initiator = value;
                setWorkflows(newWorkflows);
              }}
            />
          </div>

          <div>
            {!hideApprovers && (
              <FormFieldSet
                title="Approvers"
                type="usersForEonboarding"
                placeholder="Select Approvers"
                multiple={multiple}
                value={workflows[0]?.approvers || ""}
                onChange={(value) => {
                  const newWorkflows = [...workflows];
                  newWorkflows[0].approvers = value;
                  setWorkflows(newWorkflows);
                }}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
